<div
  class="app-dialog-notification__wrapper"
  appResizeObserver
  *ngLet="settingsService.screenBreakpoint$ | async"
  (appResizeObserver.widthChange)="
    sizeObserver.value = {
      left: +Math.floor(wrapper.clientWidth / 2) - +Math.floor(window.clientWidth / 2),
      top: +Math.floor(wrapper.clientHeight / 2) - +Math.floor(window.clientHeight / 2)
    };
    cd.detectChanges()
  "
  (appResizeObserver.heightChange)="
    sizeObserver.value = {
      left: +Math.floor(wrapper.clientWidth / 2) - +Math.floor(window.clientWidth / 2),
      top: +Math.floor(wrapper.clientHeight / 2) - +Math.floor(window.clientHeight / 2)
    };
    cd.detectChanges()
  "
  #wrapper
>
  <div
    #window
    class="app-dialog-notification__window"
    [ngClass]="
      calculatePosition &&
      'mrgn-lft-' + sizeObserver.value?.left + ' mrgn-top-' + sizeObserver.value?.top
    "
  >
    <div
      *ngIf="showCloseButton"
      class="app-dialog-notification__close app-bg-main app-shadow"
      (click)="_onCloseClick()"
    >
      <app-svg class="w-16-px" type="none" src="/assets/img/close-secondary.svg"> </app-svg>
    </div>

    <div class="--flex --col --overflow-auto">
      <div
        class="app-dialog-notification__header"
        [ngVar]="{
          left: +Math.floor(wrapper.clientWidth / 2) - +Math.floor(window.clientWidth / 2),
          top: +Math.floor(wrapper.clientHeight / 2) - +Math.floor(window.clientHeight / 2)
        }"
        #sizeObserver="ngVar"
      >
        <ng-content select="app-dialog-notification-title"></ng-content>
      </div>

      <ng-content select="app-dialog-notification-description"></ng-content>

      <ng-content select="app-dialog-notification-footer"></ng-content>
    </div>
  </div>
</div>
